<template>
    <a :href="link" :taget="target" :title="title" class="inline-flex gap-1 items-center text-birdie-grey disabled:opacity-25 hover:bg-gray-300 hover:text-birdie-dark bg-gray-200 text-xs font-bold transition-colors py-1 px-2 rounded-md "> <LockClosedIcon class="w-3 h-3" /> upgrade plan 
    </a>
</template>

<script>

    import { LockClosedIcon } from "@heroicons/vue/20/solid";

    export default {
        props: {
            link: {
                type: String,
                default: route('subscription.index'),
            },
            target: {
                type: String,
                default: '_self',
            },
            title: {
                type: String,
                default: 'Upgrade Plan',
            },
        },
        components: {
            LockClosedIcon
        }
    }
</script>
